import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { Router, ActivatedRoute } from '@angular/router';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
// import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss']
})
export class SideBarComponent implements OnInit, OnChanges {

  @Input() map: any;
  @Input() type: any;
  @Input() layersList: any;
  @Input() labelStrings: any;
  @Input() selectedIcon: any;
  @Input() blockNumber: any;
  @Input() fullScreenView: any;
  @Input() fullScreenMapName: any;
  @Output() posNum = new EventEmitter<any>();
  @Output() closeStatus = new EventEmitter<boolean>();
  @Output() collapseEvent = new EventEmitter<boolean>();
  @Output() activeSideMenu = new EventEmitter<boolean>();
  @Input() sidebarComponent: any

  activeMenu: any;
  activeMenuClass: any;
  componentName: any;
  moduleName: any;
  isActual: any;
  time: any;
  logoFlag = true;
  disabledMapsListOfCyclone = [];
  collapseMenu = false;
  currentActive: any
  currentModule: any;
  showHome = true;

  activeMenuObj: any = {
    "extremeweather": false,
    "observedweather": false,
    "heatwatch": false,
    "coldwatches": false,
    "cyclone": false,
    "drought": false,
    "nowcastweather": false,
    "floodforecast": false,
    "drinkingwaterstress": false,
    "lightning": false,
    "webeoc": false,
    "alert": false,
    "rainfallActual": false,
    "weatherdata": false,
    'thunderstorms': false,
    'weatherforecast': false,
    'forecast': false,
    'disastermonitoring': false,
    'fogwatch': false,
    'snowwatch': false,
    'land-surface-temp': false,
    'land-subsidence': false,
    'satellite': false,
    'dryspell': false,
    'feed': false,
    'urban-heat-island': false,
    'live':false
  };

  menus = [
    // { icon: 'mi-weather', title: 'Observed Weather', link: 'observedweather/rainfall-actual/24', type: 'observedweather' },
    // { icon: 'mi-temperature', title: 'Heat Watch', link: 'heatwatches/heatwave', type: 'heatwave' },
    { icon: 'fas fa-filter', title: 'Heat Watch', link: 'heatwatch/heatwave', type: 'heatwave' },
    { icon: 'fas fa-filter', title: 'Rainfall', link: 'weatherforecast/rainfall-forecast', type: 'weatherforecast' },
    { icon: 'fas fa-filter', title: 'Forecast', link: 'forecast/wind-speed-forecast', type: 'forecast' },
    { icon: 'fas fa-city', title: 'Urban Heat Island', link: 'urban-heat-island/uhi', type: 'urban-heat-island' },
    // { icon: 'fas fa-filter', title: 'Nowcast', link: 'nowcastweather/forecast', type: 'nowcastweather' },
    { icon: 'fas fa-filter', title: 'Fog', link: 'fogwatch/fog', type: 'fog' },
    { icon: 'fas fa-filter', title: 'Lightning', link: 'lightning/light', type: 'light' },
    { icon: 'fas fa-filter', title: 'Land Subsidence', link: 'land-subsidence/ls', type: 'ls' },
    { icon: 'fas fa-filter', title: 'Cloud Top Temperature', link: 'satellite/ctt', type: 'satellite' },
    { icon: 'fas fa-filter', title: 'Metwise Alerts', link: 'metwiseAlerts/feed', type: 'feed' },
    { icon: 'fas fa-filter', title: 'metMIND', link: 'metmind/live', type: 'live' },
    { icon: 'fas fa-filter', title: 'Drought', link: 'drought', type: 'drought' },
    { icon: 'fas fa-filter', title: 'Crop Yield', link: 'crop-yield', type: 'crop-yield' },
    { icon: 'fas fa-filter', title: 'SDMP', link: 'monitoring-plan/sdmp', type: 'sdmp' },
    // { icon: 'mi-cold-_wave', title: 'Cold Watch', link: 'coldwatches/coldwave', type: 'coldwave' },
    // { icon: 'fas fa-cloud', title: 'Fog', link: 'fogwatch/fog', type: 'fog' },
    //  { icon: 'fas fa-snowflake', title: 'Snow', link: 'snowwatch/snow', type: 'snowwatch' },
    // { icon: 'mi-weather1', title: 'Weather Forecast', link: 'weatherforecast/rainfall-forecast', type: 'weatherforecast' },
    // { icon: 'mi-nowcast', title: 'Nowcast', link: 'nowcastweather/forecast', type: 'nowcastweather' },
    // { icon: 'mi-weather_alert', title: 'Alert', link: 'alert/gis', type: 'alert'},
    // { icon: 'mi-thunderstrom', title: 'Thunderstorm', link: 'thunderstorms/thunderstorm', type:'thunderstorm'},
    // { icon: 'fas fa-cloud-showers-heavy', title: 'Disaster Monitoring', link: 'disastermonitoring/monitor', type: 'monitor'},
    // { icon: 'mi-cyclones', title: 'Cyclone', link: 'cyclone/forecast', type: 'cyclone' },
    // {icon:'mi-drought', title:'Drought', link: '/drought/rainfall/24'},
    // {icon:'mi-flow-forecast', title:'Flow Forecast', link: '/flowforecast/rainfall/24'},
    // {icon:'mi-drinking-water', title:'Drinking Water', link: '/drinkingwater/rainfall/24'},
    // { icon: 'mi-weather', title: 'Weather Forecast', link: 'extremeweather/rainfall/24', type: 'extremeweather' },
    // { icon: 'mi-weather', title: 'Nowcast', link: 'nowcastweather/nowcast/24', type: 'nowcastweather' },
    // { icon: 'mi-weather', title: 'Nowcast', link: 'nowcastweather/nowcast', type: 'nowcast' },
    // { icon: 'mi-weather', title: 'Nowcast', link: 'nowcastweather/radar-forecast', type: 'radarforecast' },
    // { icon: 'mi-flow-forecast', title: 'Nowcast Flood Alerts', link: 'floodforecast/gis', type: 'floodforecast'},
    // { icon: 'mi-drought', title: 'Drought', link: 'drought/gis', type: 'drought' },
    // { icon: 'mi-drinking-water', title: 'Drinking Water Stress', link: 'drinkingwaterstress/gis', type:'drinkingwaterstress'},
    // { icon: 'fas fa-bolt', title: 'Lightning', link: 'lightning/gis', type:'lightning'},
    // { icon: 'fas fa-cloud-download-alt', title: 'Weather Data', link: 'weatherdata/mis', type: 'weatherdata'},
  ];
  menusConfig: any = {
    'heatwave': { icon: 'fas fa-filter', title: 'Heat Watch', link: 'heatwatch/heatwave', type: 'heatwave' },
    'heatindex': { icon: 'fas fa-filter', title: 'Heat Watch', link: 'heatwatch/heatindex', type: 'heatwave' },
    'seamless-temp': { icon: 'fas fa-filter', title: 'Heat Watch', link: 'heatwatch/seamless-temp', type: 'heatwave' },
    'heatlog': { icon: 'fas fa-filter', title: 'Heat Watch', link: 'heatwatch/heatlog', type: 'heatwave' },
    'seasonal-temp': { icon: 'fas fa-filter', title: 'Heat Watch', link: 'heatwatch/seasonal-temp', type: 'heatwave' },
    'weatherforecast': { icon: 'fas fa-filter', title: 'Rainfall', link: 'weatherforecast/rainfall-forecast', type: 'weatherforecast' },
    'nowcast': { icon: 'fas fa-filter', title: 'Nowcast', link: 'nowcastweather/nowcast', type: 'weatherforecast' },
    'nowcastweather': { icon: 'fas fa-filter', title: 'Nowcast', link: 'nowcastweather/forecast', type: 'weatherforecast' },
    'seamlessview': { icon: 'fas fa-filter', title: 'Nowcast', link: 'nowcastweather/seamlessview', type: 'weatherforecast' },
    'fog': { icon: 'fas fa-filter', title: 'Fog', link: 'fogwatch/fog', type: 'fog' },
    'light': { icon: 'fas fa-filter', title: 'Lightning', link: 'lightning/light', type: 'light' },
    'ls': { icon: 'fas fa-filter', title: 'Land Subsidence', link: 'land-subsidence/ls', type: 'ls' },
    'ctt': { icon: 'fas fa-filter', title: 'Cloud Top Temperature', link: 'satellite/ctt', type: 'satellite' },
    'wind-speed-forecast': { icon: 'fas fa-filter', title: 'Forecast', link: 'forecast/wind-speed-forecast', type: 'forecast' },
    'humidity-forecast': { icon: 'fas fa-filter', title: 'Forecast', link: 'forecast/humidity-forecast', type: 'forecast' },
    'uv-forecast': { icon: 'fas fa-filter', title: 'Forecast', link: 'forecast/uv-forecast', type: 'forecast' },
    'dryspell': { icon: 'fas fa-filter', title: 'Dry Spell Monitor', link: 'dryspell/dryspell', type: 'dryspell' },
    'feed': { icon: 'fas fa-filter', title: 'Metwise Alerts', link: 'metwiseAlerts/feed', type: 'feed' },
    'uhi': { icon: 'fas fa-city', title: 'Urban Heat Island', link: 'urban-heat-island/uhi', type: 'urban-heat-island' },
    'live': { icon: 'fas fa-filter', title: 'metMIND', link: 'metmind/live', type: 'live' },
    'drought': { icon: 'fas fa-filter', title: 'Drought', link: 'drought', type: 'drought' },
    'crop-yield': { icon: 'fas fa-filter', title: 'Crop Yield', link: 'crop-yield', type: 'crop-yield' },
    'sdmp': { icon: 'fas fa-filter', title: 'SDMP', link: 'monitoring-plan/sdmp', type: 'sdmp' }
  };
  lang: any;
  stateUrlId: any;
  currentLatLong = {};
  selectedDashboard: any;

  constructor(private router: Router, private route: ActivatedRoute, private utils: UtilsService) {
    this.stateUrlId = this.route.snapshot.paramMap.get('id');
    ProjConstants.STATENAME = ProjConstants.IDTOSTATENAMEMAPPING[this.stateUrlId];
    const STATENAME = ProjConstants.IDTOSTATENAMEMAPPING[this.stateUrlId];
    if (STATENAME == 'ANDHRA PRADESH') {
      this.logoFlag = true;
    } else {
      this.logoFlag = false;
    }
  }


  ngOnInit() {
    this.lang = localStorage.getItem("lang");
    // this.translate.use(this.lang.match(/en|te|hi/) ? this.lang : 'en');

    const currentModule = this.router.url.split('/')[1];
    Object.keys(this.activeMenuObj).forEach(key => {
      this.activeMenuObj[key] = key === currentModule;
    });
    this.menus.forEach(menu => {
      if (menu.link.split('/')[0] === currentModule) {
        this.activeMenu = menu.title;
        // this.activeMenuClass = 'active'
        // this.activeMenuCollapse(true)
        // Do not open sidebar panel on init — only open on filter button click
      }
    });
    this.moduleName = currentModule;
    console.log(this.moduleName, "Module Name");

    const componentArray = this.router.url.split('/')[2].split('-');
    if (componentArray.length > 1 && componentArray[1] == 'actual') {
      this.isActual = 'true';
    } else {
      this.isActual = 'false';
    }
    this.utils.disabledMaps.subscribe(res => {
      this.disabledMapsListOfCyclone = res;
    });
    this.currentModule = currentModule;
    this.utils.getShowHomeButton().subscribe(val => {
      this.showHome = val;
    })
  }

  ngOnChanges(change: SimpleChanges) {

    //this.router.events.subscribe(Event=>{
    // console.log('Event here',Event['snapshot']['_routerState'])
    //})

    if (!isNullOrUndefined(change.blockNumber) && change.blockNumber.currentValue !== change.blockNumber.previousValue) {
      this.blockNumber = change.blockNumber.currentValue;
    }
    if (!isNullOrUndefined(change.type) && change.type.currentValue !== change.type.previousValue) {
      // this.menus.forEach(menu => {

      //   if (menu.type === change.type.currentValue) {
      //     this.handleMenuClick(menu);
      //   } else if (menu.type == 'heatwave' && (change.type.currentValue == "heatindex" || change.type.currentValue == "seamless-temp")) {
      //     this.handleMenuClick(menu);
      //   } else if (change.type.currentValue == 'nowcast') {
      //     menu.link = change.type.currentValue == 'nowcastweather' ? 'nowcastweather/forecast' : 'nowcastweather/nowcast'
      //     this.handleMenuClick(menu);
      //   }
      // });
      this.selectedDashboard = change.type.currentValue
      this.handleMenuClick();
    }
  }

  sidemenuCollapse() {
    this.collapseMenu = !this.collapseMenu
    this.collapseEvent.emit(this.collapseMenu);
  }

  collapseActive: boolean = false;

  activeMenuCollapse(value: any) {
    this.collapseActive = value;
    if (this.moduleName === 'drinkingwaterstress') {
      this.collapseActive = false;
    }
    this.activeSideMenu.emit(this.collapseActive);
  }

  get isSeamlessView(): boolean {
    return this.router.url.includes('/seamlessview');
  }

  handleMenuClick(): void {
    const menu = this.menusConfig[this.selectedDashboard]
    console.log("Menu", menu);
    // currentrouteloc.
    this.componentName = this.router.url.split('/')[2];
    this.moduleName = this.router.url.split('/')[1];
    if (!menu) {  // ← ADD NULL GUARD
    console.warn('No menu config for:', this.selectedDashboard);
    return;
    }    this.time = this.route.snapshot.paramMap.get('time');
    const id = this.route.snapshot.paramMap.get('id');
    const link = menu.link
    if (menu.link.split('/')[0] != this.moduleName) {
      console.log("link.split('/')", link.split('/'));
      this.router.navigate(link.split('/'),);
    }
    else {
      // if (isNullOrUndefined(this.activeMenu) || this.activeMenu != menu.title) {
      //   this.currentActive = menu.title;
      //   this.activeMenu = menu.title;
      //   this.activeMenuClass = 'active';
      //   this.activeMenuCollapse(true);
      // } else if (!isNullOrUndefined(this.activeMenu) && this.activeMenu == menu.title) {
      //   if (menu.title === 'Cyclone' && this.disabledMapsListOfCyclone.length !== 2) {
      //     // alert('Please select appropriate number of maps to display');
      //   } else {
      //     if (menu.title === 'Cyclone' && this.disabledMapsListOfCyclone.length === 2) {
      //       this.closeStatus.emit(true);
      //     }
      //     this.activeMenu = null;
      //     this.activeMenuClass = '';
      //     this.activeMenuCollapse(false);
      //   }
      // }
      if (!this.activeMenu || this.activeMenu !== menu.title) {
        // Show sidebar for selected menu item
        this.currentActive = menu.title;
        this.activeMenu = menu.title;
        this.activeMenuClass = 'active';
        this.activeMenuCollapse(true);
      } else if (this.activeMenu === menu.title) {
        // Hide sidebar if the same menu item is clicked again
        if (this.moduleName === 'urban-heat-island') {
          // Urban Heat Island sidebar must always stay expanded
          return;
        }
        if (menu.title === 'Cyclone' && this.disabledMapsListOfCyclone.length !== 2) {
          // alert('Please select appropriate number of maps to display');
        } else {
          if (menu.title === 'Cyclone' && this.disabledMapsListOfCyclone.length === 2) {
            this.closeStatus.emit(true);
          }
          this.activeMenu = null;
          this.activeMenuClass = '';
          this.activeMenuCollapse(false);
        }
      }
      if (this.componentName == 'forecast' || this.componentName == 'radar-forecast') {
        // this.closeStatus.emit(true);
        // this.activeMenu = null;
        // this.activeMenuClass = '';
        // this.activeMenuCollapse(false);
      }
      // this.router.navigate([this.moduleName, this.componentName, this.time]);
    }
    // this.currentActive = this.route['_routerState']['snapshot']['url'].split('/').splice(1)[0]
    // console.log('current Route',this.route['_routerState']['snapshot']['url'].split('/').splice(1)[0])

  }

  closeMenu() {
    if (this.moduleName === 'urban-heat-island') {
      // Urban Heat Island sidebar cannot be closed/collapsed
      return;
    }
    if (this.activeMenu === 'Cyclone' && this.disabledMapsListOfCyclone.length !== 2) {
      alert('Please select appropriate number of maps to display');
    } else {
      if (this.activeMenu === 'Cyclone' && this.disabledMapsListOfCyclone.length === 2) {
        this.closeStatus.emit(true);
      }
      this.activeMenuClass = '';
      this.activeMenuCollapse(false);
      this.activeMenu = null;
    }
  }

  sendPlayPos(event: any) {
    this.posNum.emit(event);
  }

  getActive(comp: any) {
    const currentModule = this.router.url.split('/')[1];
      const currentComponent = this.router.url.split('/')[2]; // ← ADD

    if (comp.type === 'heatwave') {
      return ['heatwatch', 'heatwatches'].includes(currentModule) && currentComponent!=='wind-speed-forecast'; // ← MODIFY
    }
    if (comp.type === 'weatherforecast') {
      return ['weatherforecast', 'nowcastweather'].includes(currentModule);
    }
     if (comp.type === 'forecast') {
        return currentModule === 'forecast' && (currentComponent === 'wind-speed-forecast' || currentComponent === 'humidity-forecast' || currentComponent === 'uv-forecast');
  }
    return comp.link.split("/")[0] === currentModule;
  }

  goHome() {
    console.log(this.utils.getDeviceType())
    this.currentLatLong = this.utils.getCurrentLatLongFromLS();
    console.log(this.currentLatLong)
    this.router.navigate(['landing-page'])
    // this.router.navigate(['/'])
  }

  isMobile() {
    return this.utils.getDeviceType() == "mobile";
  }

  gotoWebeocPortal() {
    this.router.navigate(['webeocportal']);

  }
  gotostateReport() {
    this.router.navigate(['statereport']);

  }
}
